<div class="row">
  <div class="col-xl-6">
    <nz-select
      nzShowSearch
      nzAllowClear
      [(ngModel)]="selectedCountryId"
      nzPlaceHolder="Select country"
      [ngClass]="className" (ngModelChange)="countryChange()" (focus)="onTouched()" [nzDisabled]="isDisabled"
    >
      <nz-option *ngFor="let item of countries" [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
    </nz-select>
  </div>
  <div class="col-xl-6">
    <nz-select
      nzShowSearch *ngIf="!isVisibleCityName()"
      nzAllowClear
      [(ngModel)]="selectedCityId"
      nzPlaceHolder="Select city"
      [ngClass]="className" (ngModelChange)="cityChange()" (focus)="onTouched()" [nzDisabled]="isDisabled"
    >
      <nz-option *ngFor="let item of destcities" [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
    </nz-select>
    <input [ngClass]="className" *ngIf="isVisibleCityName()" (ngModelChange)="cityChange()" (focus)="onTouched()" nz-input placeholder="City name" [(ngModel)]="selectedCityName" />
  </div>
</div>
